import type { PageContext } from '~/Features/Configuration/Utils/PageContext';
import { themeDefaultValues, themeModernValues } from '~/Utils/Theme';

export const getPageTheme = (context?: PageContext) => {
    switch (context) {
        case 'spa':
        case 'modernPage':
            return themeModernValues;
        default:
            return themeDefaultValues;
    }
};
